module.exports = __webpack_public_path__ + "img/logo.616b1a29.png";